// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JGk-C","noPadding":"styles_noPadding__nUgrZ"};